document.addEventListener('DOMContentLoaded', function() {
  // Get all custom select dropdowns on the page
  const customSelects = document.querySelectorAll(".custom-select");

  customSelects.forEach((customSelect) => {
    const selectBtn = customSelect.querySelector(".select-button");
    const selectedValue = customSelect.querySelector(".selected-value");
    const optionsList = customSelect.querySelectorAll(".select-dropdown li");

    if (!selectBtn || !selectedValue) return;

    // Add click event to select button
    selectBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      
      // Close all other dropdowns
      customSelects.forEach((otherSelect) => {
        if (otherSelect !== customSelect) {
          otherSelect.classList.remove("active");
          const otherBtn = otherSelect.querySelector(".select-button");
          if (otherBtn) {
            otherBtn.setAttribute("aria-expanded", "false");
          }
        }
      });
      
      // Toggle current dropdown
      customSelect.classList.toggle("active");
      
      // Update the aria-expanded attribute based on the current state
      selectBtn.setAttribute(
        "aria-expanded",
        selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true"
      );
    });

    optionsList.forEach((option) => {
      function handler(e) {
        // Click Events
        if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {
          selectedValue.textContent = this.children[1].textContent;
          customSelect.classList.remove("active");
          selectBtn.setAttribute("aria-expanded", "false");
          
          // Check the radio button
          const radio = this.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
          }
        }
        // Key Events
        if (e.key === "Enter") {
          selectedValue.textContent = this.children[1].textContent;
          customSelect.classList.remove("active");
          selectBtn.setAttribute("aria-expanded", "false");
          
          // Check the radio button
          const radio = this.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
          }
        }
      }

      option.addEventListener("keyup", handler);
      option.addEventListener("click", handler);
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", (e) => {
    customSelects.forEach((customSelect) => {
      if (!customSelect.contains(e.target)) {
        customSelect.classList.remove("active");
        const selectBtn = customSelect.querySelector(".select-button");
        if (selectBtn) {
          selectBtn.setAttribute("aria-expanded", "false");
        }
      }
    });
  });
});